import { useState } from "react";
import { useFeedback } from "../../../contexts/FeedbackContext";
import { useFetch } from "../../../hooks/useFetch";
import { ParentProductDetails } from "../models/ParentProductDetails";
import { useParentProducts } from "../contexts/ParentProductsContext";
import { useLocalization } from "../../../contexts/LocalizationContext";
import { apiRoutes } from "../../../apiRoutes";

export const useParentProductsActions = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { request } = useFetch();
  const { pushNotification, showModal } = useFeedback();
  const { getParentProducts, onEditModeIdChange } = useParentProducts();
  const { translate } = useLocalization();

  const handleDelete = (parentProductId: number) => {
    const handleContinue = async () => {
      showModal(null);
      setIsLoading(true);
      await request({
        route: apiRoutes.parentProducts.deleteParentProduct(parentProductId),
        method: "DELETE",
        onSuccess: async () => {
          await getParentProducts();
          pushNotification({ message: translate("request.parentProducts.deleteSuccess"), type: "success" });
        },
        onFailure: () => pushNotification({ message: translate("request.parentProducts.deleteFail"), type: "danger" }),
        onAny: () => setIsLoading(false)
      });
    };

    showModal({
      isVisible: true,
      message: translate("plugins.removeParentProduct"),
      handleClose: () => showModal(null),
      handleContinue
    });
  };

  const handleUpdate = async (parentProductId: number, value: ParentProductDetails) => {
    setIsLoading(true);
    await request({
      route: apiRoutes.parentProducts.updateParentProduct(parentProductId),
      body: JSON.stringify(value),
      contentType: "application/json",
      method: "PUT",
      onSuccess: async () => {
        onEditModeIdChange(-1);
        await getParentProducts();
        pushNotification({ message: translate("request.parentProducts.updateSuccess"), type: "success" });
      },
      onFailure: () => pushNotification({ message: translate("request.parentProducts.updateFail"), type: "danger" }),
      onAny: () => setIsLoading(false)
    });
  };

  const handleCreate = async (value: ParentProductDetails) => {
    setIsLoading(true);
    await request({
      route: apiRoutes.parentProducts.createParentProduct(),
      body: JSON.stringify(value),
      contentType: "application/json",
      method: "POST",
      onSuccess: async () => {
        onEditModeIdChange(-1);
        await getParentProducts();
        pushNotification({ message: translate("request.parentProducts.updateSuccess"), type: "success" });
      },
      onFailure: () => pushNotification({ message: translate("request.parentProducts.updateFail"), type: "danger" }),
      onAny: () => setIsLoading(false)
    });
  };

  return {
    isLoading,
    handleUpdate,
    handleDelete,
    handleCreate
  };
};
